import * as React from 'react';
import {
  objectSelector,
  thumbnailImageUrl,
} from 'theme/utils';
import Image from 'theme/Image';
import $S from 'theme/settings';

export default class Colors extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedVariant: '',
    };
  }

  componentDidMount() {
    const { variantConfig } = this.props;

    this.props.variant.options.forEach((item) => {
      item.is_selected &&
        this.setState({
          selectedVariant: objectSelector(
            item,
            variantConfig.selectedColorText
          ),
        });
    });
  }

  componentWillReceiveProps(nextProps) {
    const { variantConfig } = this.props;

    nextProps.variant.options.forEach((item) => {
      item.is_selected &&
        this.setState({
          selectedVariant: objectSelector(
            item,
            variantConfig.selectedColorText
          ),
        });
    });
  }

  render() {
    const { variant, variantSelection, variantConfig } = this.props;

    return (
      <div className='variants variants--color'>
        {this.state.selectedVariant ? (
          <div className='variants--anonymous__title'>
            {variant.attribute_name}: &nbsp;{' '}
            {this.state.selectedVariant}
          </div>
        ) : (
          <div className='variants--anonymous__title'>
            {variant.attribute_name}
          </div>
        )}
        {variant.options.map((item, i) => {
          const disable = !item['in_stock'];
          const selected = item['is_selected'];
          return (
            <div
              className={`variant variant--color ${disable ? 'disable' : ''} ${
                selected ? 'selected' : ''
              }`}
              key={i}
              onClick={() =>
                variantSelection(
                  variantConfig.key,
                  objectSelector(item, variantConfig.value)
                )
              }
            >
              <Image
                src={thumbnailImageUrl(
                  objectSelector(item, variantConfig.label),
                  $S.productDetailColorsImageWidth,
                  $S.productDetailColorsImageHeight,
                  $S.productDetailColorsImageQuality
                )}
                width={$S.productDetailColorsImageWidth}
                height={$S.productDetailColorsImageHeight}
              />
            </div>
          );
        })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/plugins/tfs/pages/product/detail/Colors.js